import { snakeCase } from 'es-toolkit/compat';
// Descriptions must name sibling tools as the runtime exposes them: MCP uses the
// framework's `snakeCase(canonicalName)`, except generateVisualization → render_chart.
export const toolNameFor = (canonicalName, runtime) => {
    if (runtime === 'agent')
        return canonicalName;
    return canonicalName === 'generateVisualization'
        ? 'render_chart'
        : snakeCase(canonicalName);
};
//# sourceMappingURL=discoveryToolNames.js.map